<script lang="ts" setup>
import Co2ValueForm from '@/components/co2quiz/Co2ValueForm.vue';
import ListFilter from '@/components/common/ListFilter.vue';
import TranslatedState from '@/components/common/TranslatedState.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Co2BasketValue } from '@/models/co2-quiz.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import {
  Co2QuizStoreActions,
  Co2QuizStoreState,
} from '@/stores/co2-quiz.store';
import { LabelsActions } from '@/stores/labels.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const events = useEvents();

const questions = computed<Co2BasketValue[]>(() => store.state.co2.values);

const update = () => {
  store.dispatch(Co2QuizStoreActions.GetCo2Questions);
  store.dispatch(Co2QuizStoreActions.GetCo2Values);
};

onMounted(() => {
  store.dispatch(LabelsActions.GetLabels);

  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Category', key: 'categories', width: '30%' },
  { title: 'Value', key: 'value', width: '20%' },
  { title: 'State', key: 'translated', sortable: false, width: '5%' },
];

const editValue = (_: Event, { item }: { item: Co2BasketValue }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2ValueForm),
    data: item,
  });
};

const addValue = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(Co2ValueForm),
  });
};

const filterTitle = ref<string>('');
const filteredValues = computed(() =>
  questions.value.filter((v) =>
    filterTitle.value
      ? v.categories
          .map((c) => c.title)
          .join('')
          .toLowerCase()
          .indexOf(filterTitle.value) !== -1
      : true,
  ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filterTitle.value = filters.filterTitle;
}
</script>
<template>
  <v-container>
    <h2>CO₂ Values <CurrentLanguage /></h2>
    <ListFilter @filter="updateFilter" />
    <v-data-table
      density="compact"
      :headers="headers"
      :items="filteredValues"
      @click:row="editValue"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.translated="{ item }">
        <TranslatedState :item="item" />
      </template>
      <template v-slot:item.categories="{ item }">
        {{ item.categories[0]?.title }}
      </template>
    </v-data-table>

    <v-btn @click="addValue" color="success" class="mr-4">Add Value</v-btn>
  </v-container>
</template>
